import React from "react";
import PropTypes from "prop-types";
import NoteTooltip from "./NoteTooltip";

export default function NoteTooltipTableCell({
  color = undefined,
  note,
  className = "text-center td-shrink-icon"
}) {
  return note ? (
    <td className={className}>
      <NoteTooltip color={color} note={note} />
    </td>
  ) : (
    <td />
  );
}

NoteTooltipTableCell.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  note: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/NoteTooltip/NoteTooltipTableCell.jsx